import { render, staticRenderFns } from "./ttsModal.vue?vue&type=template&id=6ffdd888&scoped=true&"
import script from "./ttsModal.vue?vue&type=script&lang=js&"
export * from "./ttsModal.vue?vue&type=script&lang=js&"
import style0 from "./ttsModal.vue?vue&type=style&index=0&id=6ffdd888&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdd888",
  null
  
)

export default component.exports